<template>
  <b-row>
    <b-col cols="12" class="pr-0 pl-0">
      <b-row align-h="between">
        <b-col class="h6 mt-1" cols="auto">
          <i class="far fa-calendar-day fa-lg mr-2 ml-2"></i>
          <i v-if="isConfirmed" class="fa fa-circle fa-lg" style="color: #28a745" v-b-tooltip.hover :title="$t('views.excmdailyplan.create.confirmed')"></i>
          <i v-else class="fa fa-circle fa-lg" style="color: #dc3545" v-b-tooltip.hover :title="$t('views.excmdailyplan.create.notConfirmed')"></i>
          {{ $t('menu.dailyplan.show') }}
        </b-col>
        <b-col cols="auto">
          <span v-if="serviceman.name && serviceman.surname"><b>{{ serviceman.name }} {{ serviceman.surname }}</b></span>
          <span v-if="serviceman.userEmail">
            <br>
            <a :href="'mailto: ' + serviceman.userEmail">{{ serviceman.userEmail }}</a>
          </span>
        </b-col>
      </b-row>
      <b-row v-if="dailyPlanItems && dailyPlanItems.length > 0">
        <b-col>
          <table class="table table-sm">
            <tr>
              <th>{{ $t('views.exsborder.list.idCase') }}</th>
              <th>{{ $t('routes.EXCMTaskShow') }}</th>
              <th>{{ $t('views.timetable.dashboard.trasnferedBy') }}</th>
              <th>{{ $t('modals.excmtask.startDate') }}</th>
              <th>{{$t('views.excmcase.form.contractorUserData')}}</th>
              <th>{{$t('views.excmcase.form.partnerUserData')}}</th>
              <th></th>
            </tr>
            <tbody>
            <tr v-for="(item, index) in dailyPlanItems" :key="item['@id']">
              <td>
                <router-link v-if="item.task.idCase" :to="{name: 'EXCMCaseShow', params: { id: item.task.idCase['@id'] }}">
                  <span v-if="item.task.idCase.number">#{{item.task.idCase.number}}</span>
                  <span v-else>{{getIdFromLink(item.task.idCase['@id'])}}</span>
                </router-link><br>
                <template v-if="item.status === 1">
                  <b-badge v-if="item.task.finished === 1" variant="success">{{ $t('global.over')}}</b-badge>
                  <b-badge v-else-if="item.task.finished === 0 && item.task.started === 1" variant="warning">{{ $t('global.processing')}}</b-badge>
                  <b-badge v-else-if="item.task.finished === 0 && item.task.started === 0" variant="danger">{{ $t('global.notStarted')}}</b-badge>
                </template>
                <template v-else-if="item.status === 0">
                  <b-badge variant="danger">{{ $t('global.held')}}</b-badge>
                </template>
                <template v-else-if="item.status === 2">
                  <b-badge v-if="item.dateStart && item.dateStop" variant="warning">{{ $t('global.movedStarted')}}</b-badge>
                  <b-badge v-else variant="warning">{{ $t('global.movedNotStarted')}}</b-badge>
                </template>
                <template v-else-if="item.status === 3">
                  <b-badge v-if="item.dateStart && item.dateStop" variant="warning">{{ $t('global.movedToMainStarted')}}</b-badge>
                  <b-badge v-else variant="warning">{{ $t('global.movedToMainNotStarted')}}</b-badge>
                </template>
              </td>
              <td>{{ item.task.idTaskType.title }}</td>
              <td>{{item.task.lastPoolTask.operationUserData.fullName}}</td>
              <td>
                <span>{{ $moment(item.date).format('YYYY-MM-DD HH:mm') }}</span><br>
                <b-badge v-if="isItemMoved(item['@id'])" variant="warning">
                  {{ $t('global.movedNotStarted') }}
                </b-badge>
              </td>
              <td>
                <div v-if="item.task.idCase.contractorUserData">
                  <span v-if="item.task.idCase.contractorUserData.firmname1">{{item.task.idCase.contractorUserData.firmname1}}</span>
                  <span v-else-if="item.task.idCase.contractorUserData.fullName">{{item.task.idCase.contractorUserData.fullName}}</span>
                  <div v-if="item.task.idCase.contractorUserData.phone">{{$t('views.excmcase.show.phone')}}: <phoneNumberLink :phoneNumber="item.task.idCase.contractorUserData.phone"/></div>
                  <div v-if="item.task.idCase.contractorUserData.mobilePhone">{{$t('views.excmcase.show.mobilePhone')}}: <phoneNumberLink :phoneNumber="item.task.idCase.contractorUserData.mobilePhone"/></div>
                  <div>{{ item.task.idCase.contractorUserData.fullAddress }}</div>
                  <div v-if="item.task.idCase.contractorUserData.userEmail"><a :href="'mailto:' + item.task.idCase.contractorUserData.userEmail">{{ item.task.idCase.contractorUserData.userEmail }}</a></div>
                  <div v-if="item.task.idCase.contractorUserData.contactEmail"><a :href="'mailto:' + item.task.idCase.contractorUserData.contactEmail">{{ item.task.idCase.contractorUserData.contactEmail }}</a></div>
                </div>
              </td>
              <td>
                <div v-if="item.task.idCase.partnerUserData">
                  <span v-if="item.task.idCase.partnerUserData.firmname1">
                    {{item.task.idCase.partnerUserData.firmname1}}
                  </span>
                  <span v-else-if="item.task.idCase.partnerUserData.fullName">
                    {{item.task.idCase.partnerUserData.fullName}}
                  </span>
                  <div v-if="item.task.idCase.partnerUserData.userEmail">
                    <a :href="'mailto:' + item.task.idCase.partnerUserData.userEmail">
                      {{ item.task.idCase.partnerUserData.userEmail }}
                    </a>
                  </div>
                  <div v-if="item.task.idCase.partnerUserData.contactEmail">
                    <a :href="'mailto:' + item.task.idCase.partnerUserData.contactEmail">
                      {{ item.task.idCase.partnerUserData.contactEmail }}
                    </a>
                  </div>
                </div>
              </td>
              <td>
                <div class="btn-group float-right">
                  <button
                    v-if="!isItemMoved(item['@id'])"
                    type="button"
                    class="btn btn-link fa fa-map-marked-alt fa-lg"
                    v-b-tooltip.hover :title="$t('buttons.showMap')"
                    @click="showMap(index)">
                  </button>
                  <router-link tag="button" class="btn btn-link fa fa-arrow-right fa-lg"
                               v-b-tooltip.hover :title="$t('buttons.gotoTask')"
                               :to="{name: 'EXCMTaskShow', params: { id: item.task['@id'] }}">
                  </router-link>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          {{ $t('views.excmcase.list.noTasks') }}
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import getId from '@/utils/getIdFromLink'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink.vue'

export default {
  name: 'DailyPlan',
  data () {
    return {
      isConfirmed: null
    }
  },
  props: {
    dailyPlanItems: {
      type: Array,
      required: true
    },
    serviceman: {
      type: Object,
      required: true
    }
  },
  watch: {
    dailyPlanItems: {
      immediate: true,
      handler (val) {
        if (val && val.length > 0) {
          this.isConfirmed = Boolean(val[0].confirmed)
        }
      }
    }
  },
  components: {
    PhoneNumberLink
  },
  created () {
  },
  methods: {
    isItemMoved (id) {
      let moveReason = this.dailyPlanItems.find(task => task['@id'] === id).moveReason
      return moveReason ? true : moveReason === ''
    },
    showMap (index) {
      this.$store.state.map.center = index
      this.$emit('showMap')
    },
    getIdFromLink (link) {
      return parseInt(getId(link))
    }
  }
}
</script>

<style scoped>

</style>
